import { Animated, Easing, Platform } from 'react-native';
var getTimingAnimation = (animatedOpacity, toValue, animationDuration) => {
  return Animated.timing(animatedOpacity, {
    toValue,
    duration: animationDuration / 2,
    easing: Easing.linear,
    useNativeDriver: Platform.OS !== 'web'
  });
};
export var startLoadingAnimation = (animatedOpacity, animationDuration) => {
  Animated.loop(Animated.sequence([getTimingAnimation(animatedOpacity, 1, animationDuration), getTimingAnimation(animatedOpacity, 0, animationDuration)])).start();
};
export var startLoadingGradientAnimation = (animated, animationDuration) => {
  Animated.loop(Animated.sequence([getTimingAnimation(animated, 1, animationDuration * 2), getTimingAnimation(animated, 0, 2)])).start();
};
export var getInterpolatedOpacityValue = animatedOpacity => {
  return animatedOpacity.interpolate({
    inputRange: [0, 1],
    outputRange: [0.3, 1]
  });
};